<template>
  <div>
    <i-dropdown>
      <template v-slot:trigger="{toggle, attrs}">
        <i-button variant="simple" :title="LANG.moreOptionsLabel" @click.prevent="toggle" v-bind="attrs">
          <i-icon icon="ellipsis-h"></i-icon>
        </i-button>
      </template>
      <template v-slot:default="{close}">
        <i-menu-list class="pull-right">
          <i-menu-action
            :label="LANG.deleteRealm"
            icon="trash"
            @click.prevent="() => { showConfirmationModal = true; close(); }"
            :enabled="checkACL('/data/ts/realm/delete')"
          />
        </i-menu-list>
      </template>
    </i-dropdown>

    <i-modal :title="LANG.confirmation" v-model:show="showConfirmationModal">
      {{ LANG.confirmDeleteRealm }}<br><br>{{ realm.name }}
      <template #footer>
        <i-button variant="secondary" @click.prevent="showConfirmationModal=false">
          {{ LANG.cancel }}
        </i-button>
        <i-button variant="primary"
          @click.prevent="deleteRealm({ name: realm.name }); showConfirmationModal = false;">
          {{ LANG.delete }}
        </i-button>
      </template>
    </i-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    realm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showConfirmationModal: false,
    };
  },
  methods: {
    ...mapActions('tags', [
      'deleteRealm',
    ]),
  },
  computed: {
    ...mapState(['LANG']),
    ...mapGetters(['checkACL']),
  },
};
</script>

<style scoped lang='scss'>
  .i-button.i-simple-btn.active::v-deep {
    background: $i-list-selected-bg;
  }
</style>
